import React from "react";
import { Modal, Row } from "react-bootstrap";
import { Vortex } from "react-loader-spinner";

const NftboxModal = ({ showModal, MintingTimer, process }) => {
  return (
    <Modal
      show={showModal}
      className="walker_detail"
      centered
      size="l"
      backdrop="static"
    >
      <Modal.Body>
        <Row>
          <Vortex
            visible={showModal === true}
            height="80"
            width="80"
            ariaLabel="vortex-loading"
            wrapperStyle={{}}
            wrapperClass="vortex-wrapper"
            colors={[
              "#6610f2",
              "#6f42c1",
              "blue",
              "#300d39",
              "#212529",
              "purple",
            ]}
          />
          <div className="" style={{ display: "grid" }}>
            <p style={{ margin: "auto" }}>
              Please wait.....
              {MintingTimer && `${MintingTimer} seconds`}
            </p>
            <p style={{ margin: "auto" }}>{process}</p>
          </div>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default NftboxModal;